import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import InformationIcon from "../../icons/information.svg";
import InformationFilledIcon from "../../icons/information-filled.svg";
import "./InfoIcon.scss";
const infoIconColor = "#2D2926";
export const InfoIcon = ({ onClick, isOpen }) => {
    return (_jsx(_Fragment, { children: isOpen ? (_jsx(InformationFilledIcon, { onClick: onClick, className: "infoIcon__svg", fill: infoIconColor })) : (_jsx(InformationIcon, { className: "infoIcon__svg", fill: infoIconColor })) }));
};
//# sourceMappingURL=InfoIcon.js.map